import { render, staticRenderFns } from "./RequestPdfButton.vue?vue&type=template&id=28ad3a99&scoped=true&"
import script from "./RequestPdfButton.vue?vue&type=script&lang=js&"
export * from "./RequestPdfButton.vue?vue&type=script&lang=js&"
import style0 from "./RequestPdfButton.vue?vue&type=style&index=0&id=28ad3a99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad3a99",
  null
  
)

export default component.exports